import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BusInterface } from '@app/shared/models/bus.model';
import { BusService } from '@app/shared/services/bus.service';
import { NGXLogger } from 'ngx-logger';
import { first } from 'rxjs/operators';
import { MapService } from '../map/map-services/map.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'ty-bus',
  templateUrl: './bus.component.html',
  styleUrls: ['./bus.component.scss'],
})
export class BusComponent implements OnInit {
  listOfBus!: BusInterface[];

  constructor(
    private logger: NGXLogger,
    private busService: BusService,
    private router: Router,
    private mapService: MapService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.getBusList();
    this.clearMap();
    // TODO: si estoy en Android / ios, permisos para grabar los favoritos se hace todo desde el webView, pero hacen falta permisos igual para guardar??.

    // alert(this.checkSystem());
  }

  getBusList(): void {
    console.log('Llamada getBusList ---');
    this.busService
      .getBusList()
      .pipe(first())
      .subscribe(
        (res: BusInterface[]) => {
          console.log('Subscripción de getBusList ---');
          this.listOfBus = res;
        },
        (err) => {
          this.logger.error(
            `Error al cargar los autobuses en: bus.component.ts GetBusList() ${err.message}`
          );
          this.snackBar.open('Error al cargar la lista de los Buses', 'Aceptar', {
            duration: 6000,
          });
        }
      );
  }

  getBusRoute(bus: BusInterface): void {
    if (this.router.url.includes(this.busService.simulatePath)) {
      this.router.navigate([this.busService.simulatePath, 'stops'], {
        queryParams: {
          bus: bus.route_id,
          busCode: bus.route_short_name,
          busName: bus.route_long_name,
          color: bus.route_color,
        },
      });
    } else {
      this.router.navigate(['stops'], {
        queryParams: {
          bus: bus.route_id,
          busCode: bus.route_short_name,
          busName: bus.route_long_name,
          color: bus.route_color,
        },
      });
    }
  }

  clearMap(): void {
    this.mapService.clearMap();
  }

  checkSystem() {
    console.log('agent is:', window?.navigator?.userAgent);

    console.log('platform is: ', window?.navigator?.platform);

    // https://stackoverflow.com/questions/38241480/detect-macos-ios-windows-android-and-linux-os-with-js
    // https://stackoverflow.com/questions/75425363/how-to-detect-webview-in-javascript-for-ios-and-android

    // const userAgent = window.navigator.userAgent,
    //   platform = window.navigator?.userAgentData?.platform || window.navigator.platform,
    //   macosPlatforms = ['macOS', 'Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
    //   windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
    //   iosPlatforms = ['iPhone', 'iPad', 'iPod'];
    // let os = null;

    // if (macosPlatforms.indexOf(platform) !== -1) {
    //   os = 'Mac OS';
    // } else if (iosPlatforms.indexOf(platform) !== -1) {
    //   os = 'iOS';
    // } else if (windowsPlatforms.indexOf(platform) !== -1) {
    //   os = 'Windows';
    // } else if (/Android/.test(userAgent)) {
    //   os = 'Android';
    // } else if (/Linux/.test(platform)) {
    //   os = 'Linux';
    // }

    // return os;
  }
}
